import styled from 'styled-components';
import { THEME_COLORS } from '../../styles/theme';
import { TextBlock } from '../text';
import { FontFamilyBold, FontSize14 } from '../fonts';
import { MarginBottom10 } from '../margins';

export const Container = styled.div`
    width: 100%;
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0 4px 20px 0 rgba(81, 129, 186, 0.15);
    padding: 21px 13px;
    background-color: ${props => props.theme.color[THEME_COLORS.white]};
    display: flex;
    align-items: center;
    min-height: 180px;
    
`;

export const Title = styled(TextBlock)`
    ${FontFamilyBold};
    ${MarginBottom10};
`;

export const Subtitle = styled(TextBlock)`
    ${FontSize14};
`;

export const ImageContainer = styled.div`
    width: auto;
    height: auto;
    margin-right: 20px;
`;